/**
 * A stream event for a row the panel already shows (the engine coalesces per
 * user + type + resource, so a re-mention or a new reply *refreshes* the row)
 * replaces the stale item instead of being prepended next to it.
 *
 * The server row wins. It moves to the top only when it became news again
 * (`notifiedAt` changed — the list is ordered by it); a read-state echo from
 * another tab keeps its place.
 */
export function upsertNotification<T extends { id: string; isRead: boolean; notifiedAt: string }>(
  prev: readonly T[],
  item: T
): {
  items: T[]
  /** True when the item adds to the unread count: it was absent or read before. */ newlyUnread: boolean
} {
  const existing = prev.find((i) => i.id === item.id)
  const inPlace = existing !== undefined && existing.notifiedAt === item.notifiedAt
  return {
    items: inPlace
      ? prev.map((i) => (i.id === item.id ? item : i))
      : [item, ...prev.filter((i) => i.id !== item.id)],
    newlyUnread: !item.isRead && (!existing || existing.isRead),
  }
}
